<template>
  <ModalPresentationBase
    v-if="currentFeature && open"
    ref="modal"
    :open="open"
    center
    click-to-close
    @closed="closeModal"
  >
    <div class="flex h-[450px] gap-2">
      <div class="relative w-screen max-w-[750px] rounded-xl bg-white">
        <div v-if="currentFeature.link" class="absolute top-5 left-5">
          <Button :href="currentFeature.link" target="_blank">
            <div>{{ t("read_in_helpcenter") }}</div>
            <Icon src="ArrowUpRight" skeleton="false" />
          </Button>
        </div>
        <RivePlayer :key="currentFeature.fileName" :src="getRivUrl(currentFeature.fileName)" />
      </div>
      <div class="flex w-screen max-w-[200px] flex-col justify-between rounded-xl bg-white px-5 pt-6 pb-5">
        <div class="flex flex-col gap-6">
          <div class="text-body-large-m">{{ currentFeature.title }}</div>
          <div class="text-body-default">{{ currentFeature.description }}</div>
        </div>
        <Button @click="closeModal">
          <div>{{ t("close_modal") }}</div>
        </Button>
      </div>
    </div>
  </ModalPresentationBase>
</template>

<script setup lang="ts">
  const { t, locale } = useI18n();
  const open = ref(false);
  const { currentFeature, markFeatureAsSeen } = useFeatureAnnouncements();

  const currentLocale = ref(locale.value.split("-")[0]);

  const getRivUrl = (name: string) => {
    if (currentLocale.value != "da") currentLocale.value = "en";

    return "/rive/platform/features/" + currentLocale.value + "/" + name;
  };

  watch(
    currentFeature,
    (feature) => {
      if (feature) open.value = true;
    },
    {
      immediate: true,
    }
  );

  const closeModal = () => {
    if (currentFeature.value) markFeatureAsSeen(currentFeature.value.id);
    open.value = false;
  };
</script>
